module.exports = {
  specialEmail: 'tshitengailunga@gmail.com',
  specialPassword: '$2b$10$pUaWvCIKqTCA8W/byi2Z.uEic1TgUCzLYvBIQtGkbaSAu3QBDdPJC'
};
